import { initCookies } from "../shared/cookies";
import { initFilters } from "../shared/filter";
import { initForms } from "../shared/form";
import { initNav } from "../shared/navigation";
import { initScroll } from "../shared/scroll";
import { initShows } from "./components/show";

(function () {
  initCookies()
  
  initFilters()

  initForms()

  initNav(true)

  initScroll()

  initShows()
})()